export default __webpack_public_path__ + "static/media/lp-new-backfit-logo.6cb2fd5e.svg";